import React from 'react';
import { 
  Box, Paper, Typography, TextField, Button, 
  InputAdornment, Chip, Table, TableBody, TableCell, 
  TableContainer, TableHead, TableRow, Avatar, MenuItem, Select, FormControl, IconButton, Divider
} from '@mui/material';
import { 
  Search, FileDownload, Add, HomeWork, 
  Call, AssignmentInd, Edit
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const LeadDetails = () => {
  const navigate = useNavigate();

  const rows = [
    { 
      id: 1, 
      name: 'Rahul Shinde', phone: '98765 43210', source: 'Facebook', 
      propType: 'Residential Plots', budget: '20L - 50L', goal: 'Investment', 
      timeline: 'Within 30 days', location: 'Kolhapur Road', assigned: 'Priya M.', 
      leadDate: '2026-05-06', followUpDate: 'Today 11:20 AM',
      nextComm: 'Call', leadStatus: 'Hot'
    },
    { 
      id: 2, 
      name: 'Meena Kulkarni', phone: '91234 56789', source: 'Walk-in', 
      propType: 'Farm House Plot', budget: '50L - 1Cr', goal: 'Personal Home', 
      timeline: '1-3 months', location: 'Near Highway', assigned: 'Suresh T.', 
      leadDate: '2026-05-05', followUpDate: 'Tomorrow 10:00 AM',
      nextComm: 'Visit', leadStatus: 'Warm'
    },
    { 
      id: 3, 
      name: 'Meena Kulkarni', phone: '91234 56789', source: 'Walk-in', 
      propType: 'Farm House Plot', budget: '50L - 1Cr', goal: 'Personal Home', 
      timeline: '1-3 months', location: 'Near Highway', assigned: 'Suresh T.', 
      leadDate: '2026-05-05', followUpDate: 'Tomorrow 10:00 AM',
      nextComm: 'Visit', leadStatus: 'Warm'
    },{ 
      id: 4, 
      name: 'Meena Kulkarni', phone: '91234 56789', source: 'Walk-in', 
      propType: 'Farm House Plot', budget: '50L - 1Cr', goal: 'Personal Home', 
      timeline: '1-3 months', location: 'Near Highway', assigned: 'Suresh T.', 
      leadDate: '2026-05-05', followUpDate: 'Tomorrow 10:00 AM',
      nextComm: 'Visit', leadStatus: 'Warm'
    }
    // अधिक डेटा असल्यास इथे ॲड करा
  ];

  const getStatusStyle = (status) => {
    switch(status) {
      case 'Hot': return { bg: '#ffebee', text: '#d32f2f' };
      case 'Warm': return { bg: '#fff3e0', text: '#ed6c02' };
      default: return { bg: '#f1f5f9', text: '#64748B' };
    }
  };

  return (
    <Box sx={{ 
      width: '100%', 
      height: '100vh', // पूर्ण स्क्रीनची उंची
      display: 'flex', 
      flexDirection: 'column', 
      overflow: 'hidden', // पूर्ण पेज स्क्रोल होणार नाही
      p: 2,
      boxSizing: 'border-box',
      bgcolor: '#F4F7FA'
    }}>
      
      {/* Header Section - Center Aligned */}
      <Box sx={{ textAlign: 'center', mb: 3, flexShrink: 0 }}>
        <Typography variant="h4" sx={{ fontWeight: 800, color: '#1a237e', mb: 1 }}>
          Details of Leads
        </Typography>
        <Typography variant="body2" sx={{ color: '#64748B', mb: 2 }}>
          Comprehensive view of all customer requirements and lead tracking.
        </Typography>
        <Divider sx={{ width: '80px', mx: 'auto', borderBottomWidth: 3, borderColor: '#1a237e', borderRadius: 2 }} />
      </Box>

      {/* Action Bar (Search & Button) - Fixed */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexShrink: 0 }}>
        <Box sx={{ display: 'flex', gap: 1.5 }}>
          <TextField 
            placeholder="Search name, phone or location..." 
            size="small"
            InputProps={{ 
              startAdornment: <InputAdornment position="start"><Search fontSize="small"/></InputAdornment>, 
              sx: { borderRadius: '10px', bgcolor: '#fff' }
            }}
            sx={{ width: 350 }}
          />
          <FormControl size="small" sx={{ minWidth: 140 }}>
            <Select displayEmpty defaultValue="" sx={{ borderRadius: '10px', bgcolor: '#fff' }}>
              <MenuItem value="">Property Type</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Button 
          variant="contained" 
          startIcon={<Add />} 
          onClick={() => navigate('/dashboard/inquiry')} 
          sx={{ bgcolor: '#1a237e', textTransform: 'none', borderRadius: '10px', px: 3 }}
        >
          Create New Lead
        </Button>
      </Box>

      {/* Table Container - Scrollable Area */}
     {/* Table Container - Scrollable Area */}
      <TableContainer 
        component={Paper} 
        sx={{ 
          borderRadius: '15px', 
          border: '1px solid #E2E8F0', 
          flexGrow: 1, 
          overflow: 'auto', 
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)', // प्रीमियम हलका शॅडो
          bgcolor: '#fff',
          '&::-webkit-scrollbar': { width: '6px', height: '6px' },
          '&::-webkit-scrollbar-thumb': { bgcolor: '#cbd5e1', borderRadius: '10px' }
        }}
      >
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              {['CUSTOMER INFO', 'PROPERTY PREFERENCE', 'BUDGET & GOAL', 'DATES', 'ASSIGNED', 'COMM.', 'STATUS', 'ACTIONS'].map(h => (
                <TableCell 
                  key={h} 
                  sx={{ 
                    bgcolor: '#F8FAFC', // Header चा फिक्कट बॅकग्राउंड
                    fontWeight: 700, 
                    color: '#64748B', 
                    fontSize: '0.7rem', 
                    py: 1.8,
                    borderBottom: '2px solid #E2E8F0'
                  }}
                >
                  {h}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => {
              const sStyle = getStatusStyle(row.leadStatus);
              return (
                <TableRow 
                  key={row.id} 
                  hover 
                  sx={{ '&:hover': { bgcolor: '#fbfcfd' } }} // रो होव्हर इफेक्ट
                >
                  {/* Customer Info */}
                  <TableCell sx={{ py: 1.5 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <Avatar 
                        sx={{ 
                          bgcolor: '#1a237e', 
                          width: 32, 
                          height: 32, 
                          fontSize: '0.8rem', 
                          fontWeight: 600,
                          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                        }}
                      >
                        {row.name[0]}
                      </Avatar>
                      <Box>
                        <Typography sx={{ fontWeight: 700, fontSize: '0.85rem', color: '#1E293B' }}>
                          {row.name}
                        </Typography>
                        <Typography sx={{ fontSize: '0.65rem', color: '#64748B', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                          <Call sx={{ fontSize: 10 }} /> {row.phone}
                        </Typography>
                      </Box>
                    </Box>
                  </TableCell>

                  {/* Property Preference */}
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
                      <HomeWork sx={{ fontSize: 14, color: '#1a237e' }} />
                      <Typography sx={{ fontSize: '0.75rem', fontWeight: 600, color: '#334155' }}>
                        {row.propType}
                      </Typography>
                    </Box>
                    <Chip 
                      label={row.location} 
                      size="small" 
                      sx={{ fontSize: '0.6rem', height: 18, bgcolor: '#f1f5f9', color: '#475569' }} 
                    />
                  </TableCell>

                  {/* Budget & Goal */}
                  <TableCell>
                    <Typography sx={{ fontSize: '0.8rem', fontWeight: 800, color: '#059669' }}>
                      {row.budget}
                    </Typography>
                    <Typography sx={{ fontSize: '0.65rem', color: '#64748B', fontStyle: 'italic' }}>
                      {row.goal}
                    </Typography>
                  </TableCell>

                  {/* Dates */}
                  <TableCell>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.2 }}>
                      <Typography sx={{ fontSize: '0.65rem', color: '#64748B' }}>
                        Created: <b>{row.leadDate}</b>
                      </Typography>
                      <Typography sx={{ fontSize: '0.65rem', color: '#d32f2f', bgcolor: '#fff1f2', px: 0.5, borderRadius: '4px', width: 'fit-content' }}>
                        Next: <b>{row.followUpDate}</b>
                      </Typography>
                    </Box>
                  </TableCell>

                  {/* Assigned To */}
                  <TableCell>
                    <Chip 
                      icon={<AssignmentInd sx={{ fontSize: '12px !important' }} />}
                      label={row.assigned} 
                      variant="outlined"
                      size="small"
                      sx={{ fontSize: '0.7rem', fontWeight: 500, borderColor: '#E2E8F0' }}
                    />
                  </TableCell>

                  {/* Communication */}
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: '#1976d2' }}>
                      <Call sx={{ fontSize: 14 }} />
                      <Typography sx={{ fontSize: '0.75rem', fontWeight: 600 }}>{row.nextComm}</Typography>
                    </Box>
                  </TableCell>

                  {/* Status */}
                  <TableCell>
                    <Chip 
                      label={row.leadStatus} 
                      size="small" 
                      sx={{ 
                        bgcolor: sStyle.bg, 
                        color: sStyle.text, 
                        fontSize: '0.65rem', 
                        fontWeight: 800, 
                        borderRadius: '6px',
                        minWidth: '55px'
                      }} 
                    />
                  </TableCell>

                  {/* Actions */}
                  <TableCell>
                    <IconButton 
                      size="small" 
                      onClick={() => navigate('/dashboard/inquiry', { state: { editData: row } })}
                      sx={{ 
                        bgcolor: '#f8fafc', 
                        border: '1px solid #E2E8F0', 
                        borderRadius: '8px', 
                        color: '#1a237e',
                        '&:hover': { bgcolor: '#1a237e', color: '#fff' }
                      }}
                    >
                      <Edit sx={{ fontSize: 16 }} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default LeadDetails;